export default __webpack_public_path__ + "static/media/provesional_restoration_upper_46_2@2x.d999401f.png";